// Fixed-step update with a variable-rate draw. Stops cleanly when destroyed.

export interface Loop { start(): void; stop(): void; running: boolean }

export function makeLoop(update: (dt: number) => void, draw: (alpha: number) => void, step = 1 / 60): Loop {
  let raf = 0;
  let last = 0;
  let acc = 0;
  const loop: Loop = { start, stop, running: false };
  function frame(t: number) {
    if (!loop.running) return;
    if (!last) last = t;
    let dt = (t - last) / 1000;
    last = t;
    if (dt > 0.25) dt = 0.25; // tab was hidden; do not spiral
    acc += dt;
    let n = 0;
    while (acc >= step && n < 8) { update(step); acc -= step; n++; }
    draw(acc / step);
    raf = requestAnimationFrame(frame);
  }
  function start() { if (loop.running) return; loop.running = true; last = 0; raf = requestAnimationFrame(frame); }
  function stop() { loop.running = false; cancelAnimationFrame(raf); }
  return loop;
}
